module.exports = __webpack_public_path__ + "static/googledocs-2e9b9cbc0a84de1066050cf046974cee.png";